export const headers = [
  { name: 'Operação', field: 'operation_type', sortable: true },
  { name: 'Nome', field: 'name', sortable: false },
  { name: 'Ativo', field: 'active', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
